module.exports = __webpack_public_path__ + "static/campaign-check-19dbbed3138437873a2de0cb5526fe94.png";